<script>
  import {
    VTabsItems
  } from 'vuetify/lib'
  export default {
    name: 'wh-tabs-items',
    extends: VTabsItems
  };
</script>